import Button from "@/components/Common/Buttons/Button/Button.vue";
import ModalCloseBtn from "@/components/Modal/ModalCloseBtn.vue";
import InputField from '@/components/Common/Inputs/Input/Input.vue';
import CheckBox from '@/components/Common/Inputs/CheckBox/CheckBox.vue';
import Modal from "@/components/Modal/Modal.vue";

export default {
    name: 'CoordinatesGuideModal',
    components: {
        Button,
        ModalCloseBtn,
        InputField,
        Modal,
        CheckBox
    },
    data() {
        return {

        }
    },
    methods: {
        closeModal() {
            this.$store.dispatch("utils/closeModal", this.$props.name);
        },
    }
}